import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-65a86fe5"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "logo"
};
const _hoisted_2 = {
  class: "box"
};
const _hoisted_3 = ["src"];
export default {
  __name: 'Logo',
  setup(__props) {
    const logo = require("@/assets/logo-100.svg");
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_router_link, {
        to: "/"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
          src: _unref(logo)
        }, null, 8, _hoisted_3)])]),
        _: 1
      })]);
    };
  }
};